export default "__VITE_ASSET__55a39ea0__"